<script lang="ts">
  import MobileRouter from './withdrawal/WithdrawalMobileRouter.svelte';
  import { loginUser } from '../../components/auth/LoginUser';
  import HikariCollabo from './withdrawal/WithdrawalHikariCollabo.svelte';
  import Withunet from './withdrawal/WithdrawalWithunet.svelte';
  import Umobiled from './withdrawal/WithdrawalUmobiled.svelte';
  import Premium from './withdrawal/WithdrawalPremium.svelte';

  const businessCode = $loginUser.businessCode;
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  {#if businessCode === 'UMOBILE_D' || businessCode === 'UMOBILE_D_ENECOM'}
    <Umobiled />
  {:else if businessCode === 'UMOBILE_PREMIUM'}
    <Premium />
  {:else}
    <div class="mb-6">
      <div class="container flex justify-between">
        <h1 class="text-2xl font-bold text-gray-700">解約</h1>
      </div>
      {#if businessCode === 'HIKARI_COLLABO'}
        <HikariCollabo />
      {:else if businessCode === 'WITHUNET'}
        <Withunet />
      {:else if businessCode === 'UMOBILE_EA' || businessCode === 'UMOBILE_SONET'}
        <MobileRouter />
      {/if}
    </div>
  {/if}
</div>

<style lang="postcss">
</style>
